<div class="pagetitle">
  <nav>
    <ol class="breadcrumb">
      @for (item of breadcrumbs; track item) {
        <li [class]="getClassBreadCrumb(item.active)">{{item.title}}</li>
      }
    </ol>
  </nav>
</div>